import { Svg, Path } from '@react-pdf/renderer';

const HouseOutlineIcon: React.FC<{ width?: number; height?: number }> = ({
  width = 45,
  height = 41,
}) => (
    <Svg width={width} height={height} viewBox="0 0 45 41" fill="none">
    <Path d="M22.5911 11.2727L34.251 21.6363V37.8182H10.9312V21.6363L22.5911 11.2727ZM22.5911 7.27273L7.83401 20.3636V40.9091H37.166V20.3636L22.5911 7.27273Z" fill="#C1BB00"/>
    <Path d="M29.8785 6.54545V0.909091C29.8785 0.545455 30.0607 0.363629 30.6073 0.181811C31.1538 -7.40543e-06 31.7004 0 32.4291 0C33.1579 0 33.7045 -7.40543e-06 34.251 0.181811C34.7976 0.363629 34.9798 0.545455 34.9798 0.909091V10.9091L45 20.5454H40.8097L22.4089 4.1818L4.0081 20.5454H0L22.5911 0L29.8785 6.54545Z" fill="#C1BB00"/>
    </Svg>
);

export default HouseOutlineIcon;